import callApi from "../../utils/api";
import { API_BASE_URL } from "../../utils/constants";
import { parseParams } from "../../utils";

const api = callApi(API_BASE_URL || "");

const imageUploadParams = new URLSearchParams({
  fileCategory: "MASTER_SERVICE",
  subFolders: "QUESTIONS",
  fileType: "templateUrl",
});

const questionFIleTypeMap = {
  videoURL: "VIDEO_URL",
  imageURL: "IMAGE_URL",
  audioURL: "AUDIO_URL",
};

export const CREATE_QUESTION = "/v1/api/master/bank";
export const GET_QUESTION_BY_ID = "/v1/api/master/bank/{{id}}";
export const UPDATE_QUESTION_BY_ID = `/v1/api/master/bank/{{id}}`;
export const GET_QUESIONS_INFO = "/v1/api/master/bank?{{query}}";
export const UPDATE_STATUS_BY_ID = `/v1/api/master/bank/{{id}}/{{status}}`;
export const UPLOAD_IMAGE = "/v1/api/file/upload-custom?path=IR-SERVICE/{{type}}";
export const DELETE_QUESTION_BY_ID = "/v1/api/master/bank/{{id}}";

export const GET_SECTION_ALL = "/v1/api/master/irsections";
export const GET_CHAPTER_ALL = "/v1/api/master/irchapters";
export const GET_GROUP_ALL = "/v1/api/master/group";

export const getQuestionInfo = async (payload) => {
  let query = {};
  if (payload && payload.payload) {
    query = { ...payload.payload };
  }
  let params = await new URLSearchParams(query).toString();
  return await api.get(parseParams(GET_QUESIONS_INFO, { query: params }));
};

export const getById = async (payload) =>
  api.get(parseParams(GET_QUESTION_BY_ID, payload));
export const updateById = async (payload) =>
  api.put(parseParams(UPDATE_QUESTION_BY_ID, { id: payload.id }), payload);

export const updateStatusById = async (payload) =>
  await api.put(parseParams(UPDATE_STATUS_BY_ID, payload));
export const create = async (payload) =>
  api.post(parseParams(CREATE_QUESTION), payload);
export const deleteById = async (payload) =>
  await api.delete(parseParams(DELETE_QUESTION_BY_ID, payload));
export const getSection = async (payload) => {
  let query = {};
  if (payload && payload.payload) {
    query = { ...payload.payload };
  }
  let params = await new URLSearchParams(query).toString();
  return await api.get(parseParams(GET_SECTION_ALL, { query: params }));
};

export const getChapter = async (payload) => {
  let query = {};
  if (payload && payload.payload) {
    query = { ...payload.payload };
  }
  let params = await new URLSearchParams(query).toString();
  return await api.get(parseParams(GET_CHAPTER_ALL, { query: params }));
};

export const getGroup = async (payload) => {
  let query = {};
  if (payload && payload.payload) {
    query = { ...payload.payload };
  }
  let params = await new URLSearchParams(query).toString();
  return await api.get(parseParams(GET_GROUP_ALL, { query: params }));
};

// FOR FILE UPLOAD
export const uploadImage = async (payload) => {
  if (payload.field && questionFIleTypeMap[payload.field]) {
    imageUploadParams.set("fileType", questionFIleTypeMap[payload.field]);
  }

  const config = payload.signal ? { signal: payload.signal } : {};
  return api.post(
    parseParams(UPLOAD_IMAGE, {
      type: payload.field,
      query: imageUploadParams.toString(),
    }),
    payload.formData,
    config,
    true,
  );
};
